import barba from '@barba/core';

class Slideover {
    constructor() {
        this.openClass = '_open';
        this.slideoverEl = document.querySelector('.slideover');
        this.slideoverContent = document.querySelector('.slideover-content');
        this.closeEl = document.querySelector('.slideover-close');
    }

    init() {}

    open(type, contentSource, sourceElement) {
        if (this.slideoverEl && !window.APP.helpers.ShowSlideover) {
            this.slideoverEl.classList.add(this.openClass);
            window.APP.helpers.ShowSlideover = true;

            console.log('Slideover type: ' + type);

            // Close Slideover on Button Click
            this.closeEl.addEventListener('click', this._closeEvent);

            if (contentSource === 'ajax') {
                // Get content via AJAX
                this._fetchContent(sourceElement);
            }
            else {
                // Get content by copying element in DOM
                const sourceElement = document.getElementById(contentSourceData);
                if (sourceElement) {
                    this.slideoverContent.innerHTML = sourceElement.innerHTML;
                }
            }
        }
    }
    close() {
        if (this.slideoverEl && window.APP.helpers.ShowSlideover) {
            this.slideoverEl.classList.remove(this.openClass);
            window.APP.helpers.ShowSlideover = false;

            // Empty content element
            this.slideoverContent.innerHTML = '';

            this.closeEl.removeEventListener('click', this._closeEvent);
        }
    }
    _closeEvent() {
        if (window.APP.helpers.ShowSlideover) {
            history.back();
        }
    }
    _fetchContent(url) {
        fetch(url)
            .then(response => response.text())
            .then(data => {
                // Add content to the content element
                this.slideoverContent.innerHTML = data;
            })
            .catch(error => console.error('Error loading content:', error));
    }
}

export default new Slideover();